export default "__VITE_ASSET__C_BvZco5__"